import { useParams, useNavigate } from "react-router-dom";
import { myServices } from "../data";

// Utility function to format service titles
const formatServiceTitle = (title) =>
  title.toLowerCase().replace(/[^a-z0-9]/g, "-");

function ServiceDetail() {
  const { serviceName } = useParams();
  const navigate = useNavigate();

  // Use the formatServiceTitle function to match service names
  const selectedService = myServices.find(
    (service) => formatServiceTitle(service.title) === serviceName
  );

  if (!selectedService) {
    return <p>Sorry! Service not found for "{serviceName}"</p>;
  }

  return (
    <div className="container">
      <div className="max-w-3xl mx-auto py-20">
        <h1 className="text-3xl font-semibold mb-3">{selectedService.title}</h1>
        <p className="">{selectedService.description}</p>

        {selectedService.details && (
        <div className="my-8">
          {/* If details is an object */}
          {typeof selectedService.details === "object" && !Array.isArray(selectedService.details) ? (
            <>
              <h2 className="my-2 tracking-tight">{selectedService.details.intro}</h2>
              <ul className="list-disc ml-6 space-y-3">
                {selectedService.details.features.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              <p className="mt-4">{selectedService.details.outro}</p>
            </>
          ) : (
            // If details is an array
            <ul className="list-disc ml-6 space-y-3">
              {selectedService.details.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      )}

        {selectedService.products && (
          <div className="my-10">
            <h2 className="text-xl font-semibold my-2">Products</h2>
            <p className="mb-6">Here are a List of our Value-added Services</p>
            <ul className="text-left flex gap-4">
              {selectedService.products.map((product) => (
                <li key={product.id}>
                  <button
                    className="service-card font-medium border text-blue-900 cursor-pointer hover:bg-slate-300 hover:-translate-y-1 transition-all duration-700"
                    onClick={() =>
                      navigate(
                        `/services/${serviceName}/${formatServiceTitle(
                          product.title
                        )}`
                      )
                    }
                  >
                    {product.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default ServiceDetail;